// Domain constants and types for Employment related status and mappings (DDD)

export type EmploymentStatusCode =
  | "AGY"
  | "CAR"
  | "EFT"
  | "EPT"
  | "FRC"
  | "HSE"
  | "ILL"
  | "OTH"
  | "REF"
  | "RET"
  | "SE"
  | "STU"
  | "UNB"
  | "UNE"
  | "UNK";

export const employmentStatuses: Record<EmploymentStatusCode, string> = {
  AGY: "Agency",
  CAR: "Carer",
  EFT: "Full Time Employed",
  EPT: "Part Time Employed",
  FRC: "Armed Forces",
  HSE: "House Person",
  ILL: "Not Working Due To Health",
  OTH: "Other",
  REF: "Refused",
  RET: "Retired",
  SE: "Self Employed",
  STU: "Student",
  UNB: "Unemployed With Benefits",
  UNE: "Unemployed Without Benefits",
  UNK: "Unknown",
};

export type EmploymentStatus = {
  code: EmploymentStatusCode;
  label: string;
};

export const employmentStatusList: EmploymentStatus[] = Object.entries(
  employmentStatuses,
).map(([code, label]) => ({ code: code as EmploymentStatusCode, label }));

// Maps for unknown ids (integration specifics)
export const employmentTypeIdMap: Record<string, number> = {
  Unknown: 398,
};

export const employmentTitleIdMap: Record<string, number> = {
  Unknown: 25519,
};
